'use strict';

(function() {
  if (window.__asLaunchGiftPurchaseBound) return;
  window.__asLaunchGiftPurchaseBound = true;

  function getLaunchGiftConfig() {
    var bundle = document.querySelector('[data-launch-gift-bundle]');
    if (!bundle) return null;

    return {
      bundle: bundle,
      giftVariantId: bundle.dataset.giftVariantId || '',
      giftAvailable: bundle.dataset.giftAvailable === 'true',
      startsAt: Date.parse(bundle.dataset.campaignStartAt || ''),
      endsAt: Date.parse(bundle.dataset.campaignEndAt || '')
    };
  }

  function isLaunchGiftActive(config) {
    if (!config || !config.giftVariantId || !config.giftAvailable) return false;
    if (!Number.isFinite(config.startsAt) || !Number.isFinite(config.endsAt)) return false;

    var now = Date.now();
    return now >= config.startsAt && now <= config.endsAt;
  }

  function syncLaunchGiftBundleState() {
    var config = getLaunchGiftConfig();
    if (!config) return;

    var now = Date.now();
    var campaignEnded = Number.isFinite(config.endsAt) && now > config.endsAt;
    var soldOutDuringCampaign =
      Number.isFinite(config.startsAt) &&
      Number.isFinite(config.endsAt) &&
      now >= config.startsAt &&
      now <= config.endsAt &&
      !config.giftAvailable;

    config.bundle.hidden = campaignEnded || soldOutDuringCampaign;
  }

  function syncLaunchGiftPurchaseButtons() {
    var variantSelect = document.querySelector('.as-product-variant');
    var variantsData = document.querySelector('.as-variants-data');
    if (!variantSelect || !variantsData) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsData.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    var variant = variants.find(function(item) {
      return String(item.id) === String(variantSelect.value);
    });
    if (!variant) return;

    var quantityInput = document.querySelector('.as-form-control-number');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    var config = getLaunchGiftConfig();

    document.querySelectorAll('.as-unified-variant-id').forEach(function(input) {
      input.value = variant.id;
    });
    document.querySelectorAll('.as-unified-quantity').forEach(function(input) {
      input.value = String(quantity);
    });
    document.querySelectorAll('.as-unified-shop-pay-editor-link').forEach(function(link) {
      var cartUrl = link.dataset.cartUrl || '/cart';
      var checkoutItems = [variant.id + ':' + quantity];
      if (isLaunchGiftActive(config)) {
        checkoutItems.push(config.giftVariantId + ':' + quantity);
      }
      link.href = cartUrl + '/' + checkoutItems.join(',');
    });
  }

  function prepareProductFormUi(productForm, form) {
    var addButton = form.querySelector('button[type="submit"]');
    productForm.$addToCart = addButton;
    productForm.$errorMessageWrapper = form.querySelector('.as-product-form__error-message-wrapper');
    productForm.$errorMessage = form.querySelector('.as-product-form__error-message');
  }

  document.addEventListener(
    'submit',
    function(event) {
      var form = event.target;
      if (!form || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (!form.closest('.as-unified-purchase')) return;

      var config = getLaunchGiftConfig();
      if (!isLaunchGiftActive(config)) return;

      var productForm = form.closest('product-form');
      if (!productForm || typeof productForm.add2cart !== 'function') return;

      var variantInput = form.querySelector('.as-unified-variant-id');
      var quantityInput = form.querySelector('.as-unified-quantity');
      var mainVariantId = variantInput && variantInput.value;
      var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
      if (!mainVariantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      prepareProductFormUi(productForm, form);
      productForm.add2cart([
        { id: mainVariantId, quantity: String(quantity) },
        { id: config.giftVariantId, quantity: String(quantity) }
      ]);
    },
    true
  );

  window.__asLaunchGiftGetConfig = getLaunchGiftConfig;
  window.__asLaunchGiftIsActive = isLaunchGiftActive;
  window.__asSyncLaunchGiftPurchaseButtons = syncLaunchGiftPurchaseButtons;

  function syncLaunchGiftPurchase() {
    syncLaunchGiftBundleState();
    syncLaunchGiftPurchaseButtons();
  }

  syncLaunchGiftPurchase();
  document.addEventListener('DOMContentLoaded', syncLaunchGiftPurchase);
  document.addEventListener('shopify:section:load', syncLaunchGiftPurchase);
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.as-product-variant, .as-form-control-number')) return;
    window.setTimeout(syncLaunchGiftPurchaseButtons, 0);
  });
})();
